import { render, staticRenderFns } from "./DueDataStandard.vue?vue&type=template&id=b0675c20&scoped=true"
import script from "./DueDataStandard.vue?vue&type=script&lang=js"
export * from "./DueDataStandard.vue?vue&type=script&lang=js"
import style0 from "./DueDataStandard.vue?vue&type=style&index=0&id=b0675c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0675c20",
  null
  
)

export default component.exports